const main_config_store = {
    subscribers:{},
    data_show:{
        level:true,flow:false,rain:true
    },
    period: {
        date: undefined,
        retro: false,
        start:function(){ 
            return this.date ? new Date(this.date.getTime() - (6 * 60 * 60 * 1000)).toISOString() : new Date(new Date().getTime() - (6 * 60 * 60 * 1000)).toISOString()
        },
        end:function(){ 
            return this.date ? this.date.toISOString() : new Date().toISOString()
        }
    },
    config:{
        show_station_name: false, show_max_min: true
    },
    show_modal_config:false,
    getDataShow(){
        return this.data_show
    },
    getPeriod(){
        return this.period
    },
    setPeriod(date){
        this.period.date = date
        this.publish('SET_PERIOD', this.data_show)
    },
    setDataShow(field, value){
        this.data_show[field] = value
        this.publish('SET_DATA_SHOW', this.data_show)
    },
    getConfig(path){
        return _.get(this.config, path)
    },
    setConfig(path, value){
        _.set(this.config, path, value)
        this.publish('SET_CONFIG', {path: path, value:value})
    },
    setRetro(boolean){
        this.period.retro = boolean
    },
    setConfigModalVisibility(boolean){
        this.show_modal_config = boolean
        this.publish('SET_MODAL_CONFIG_VISIBILITY', boolean)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    },
    now(){
        return new Date()
    }
}

export default main_config_store